<template>
  <article class="bg-white p-3 shadow-md rounded-md">
    <p class="font-bold py-2">
      {{ answer.question?.prompt }}
    </p>

    <div v-for="(item, index) in answer.question?.items" :key="item.id">
      <div class="p-2">
        <p>
          <b>{{ String.fromCharCode(65 + index) }}.</b> {{ item.answerText }}
        </p>
        <div
          class="p-2 my-5 flex justify-center sm:w-[14%] w-1/2 border-2 rounded border-[#79B5E1]"
        >
          <p>
            {{ answer.studentAnswers?.[index] ? "Verdadeiro" : "Falso" }}
          </p>
        </div>
        <div
          v-if="answer.studentAnswers?.[index] === item.correctAnswer"
          class="bg-[#FAFAFA] p-4 border-2 border-h-success-200 rounded"
        >
          <div class="flex flex-row items-center pb-2 gap-2">
            <v-icon
              name="hi-solid-check-circle"
              :scale="1.3"
              class="text-[#74B543]"
            />
            <span>{{
              $t("labels.generic", {
                pt: "Resposta certa",
                en: "Correct response",
              })
            }}</span>
          </div>
          <p>{{ item.answerDescription }}</p>
        </div>

        <div
          v-else
          class="bg-[#FAFAFA] p-4 border-2 border-h-error-100 rounded"
        >
          <div class="flex flex-row items-center pb-2 gap-2">
            <v-icon
              name="hi-solid-x-circle"
              :scale="1.3"
              class="text-[#BB414A]"
            />
            <span>{{
              $t("labels.generic", {
                pt: "Resposta incorreta",
                en: "Incorrect response",
              })
            }}</span>
          </div>
          <p>{{ item.answerDescription }}</p>
        </div>
      </div>
    </div>
  </article>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "TrueOrFalseCardResult",
  props: {
    answer: {
      type: Object,
      required: true,
    },
  },
});
</script>
